import React from 'react'
import ReactTable from 'react-table'

import { groupBy } from '../../../common/utils'

const commentAccessorRowLength = 60
const commentAccessor = (d) => {
  const customText = d[0].customText || ''

  const strLength = customText.length

  const rowCount = Math.ceil(strLength / commentAccessorRowLength)

  const value = []

  let lastSpaceIdx = 0
  for (let i = 0; i < rowCount; i++) {
    let chunk = customText.slice(lastSpaceIdx, lastSpaceIdx + commentAccessorRowLength)

    const isLastRow = i + 1 === rowCount

    if (!isLastRow) {
      const spaceIdx = chunk.lastIndexOf(' ')
      lastSpaceIdx += spaceIdx

      chunk = chunk.slice(0, spaceIdx)
    }

    value.push(<div key={chunk}>{chunk}</div>)
  }

  return <div key={value}>{value}</div>
}

const statusMapping = {
  notDone: '#f69595',
  pending: '#fdec9c',
  done: '#5fae5f',
}

const headerStyle = { textAlign: 'left', fontWeight: 'bold' }

const VendorsTable = ({ items }) => {
  if (!items[0].vendor) return <div style={{ padding: 20, paddingLeft: 50 }}>Du har inga uppkopplade leverantörer för tillfället</div>

  const groupedCarrierChecklistByVendor = groupBy(items, (item) => item.vendor._id)

  const data = [...groupedCarrierChecklistByVendor.values()]

  return (
    <ReactTable
      style={{ marginLeft: 50 }}
      data={data}
      columns={[
        {
          Header: <div style={headerStyle}>Leverantör</div>,
          id: 'vendor',
          Cell: ({ original }) => <div>{original[0].vendor.name}</div>,
          width: 200,
        },
        {
          Header: <div style={headerStyle}>Transportör</div>,
          id: 'carrier',
          Cell: ({ original }) => <div>{original[0].carrier.organization}</div>,
          width: 200,
        },
        {
          Header: <div style={headerStyle}>Status</div>,
          id: 'status',
          Cell: ({ original }) => (
            <div style={{ height: '100%' }}>
              <div style={{ background: statusMapping[original[0].status || 'notDone'], height: '100%' }} />
            </div>
          ),
          width: 80,
        },
        {
          Header: <div style={headerStyle}>Kommentar</div>,
          id: 'comment',
          accessor: commentAccessor,
        },
      ]}
      NoDataComponent={() => null}
      showPagination={false}
      showPageSizeOptions={false}
      loadingText="Laddar..."
      pageSize={data.length}
      className="-striped -highlight"
    />
  )
}

export default VendorsTable
